// react
import React from 'react'
// constants (data | images)
import { testimonials } from "../../../../constants/data"
import { testimonialsImages } from "../../../../constants/images"
import { Heading } from "../../../../components/UI"


// FC: Testimonials Component
const Testimonials = () => {
  return (
    <main className="testimonials | p-3 bg-primary-400">
      <section className="| flex-col gap-component jc-between my-container">
        <Heading className="text-white-900">Testimonials</Heading>
        <ul className="testimonial-grid | gap-2 my-container m-0 mx-auto">
          {testimonials.length > 0 && testimonials.map((item, index) =>
            <li
              key={item.name}
              className="our-feature-item | py-2 px-20 br-4 bg-primary-500 relative flex-col jc-center ai-center gap-8 relative pointer shadow-small">
              <div className="| circle" style={{ border: "10px solid var(--clr-white-400)" }}>
                <img loading="lazy" src={testimonialsImages[index]} alt="image" />
              </div>
              <h1 className="| fw-600 text-center text-white-900 fs-list-item-heading" style={{ margin: 0 }}>{item.name}</h1>
              <p className="| fw-400 text-center text-white-800 fs-list-item-text" style={{ margin: 0 }}>{item.description}</p>
            </li>
          )}
        </ul>
      </section>
    </main>
  )
}

export default Testimonials